"use client";

// packages/eden-headings/src/components/H3.jsx
import styled, { css } from "styled-components";
import {
  sans as zoram,
  fontSize20,
  lineHeightTight,
  fontWeightBold
} from "@churchofjesuschrist/eden-style-constants";
import { jsx } from "react/jsx-runtime";
var internalUseOnlyPriority3 = css`
  margin: 0;
  font-family: ${zoram};
  font-weight: ${fontWeightBold};
  font-size: ${fontSize20};
  line-height: ${lineHeightTight};
`;
var H3Styled = styled.h3`
  ${internalUseOnlyPriority3};
`;
var H3 = ({ children, renderAs, ...props }) => /* @__PURE__ */ jsx(H3Styled, { as: renderAs, ...props, children });
H3.displayName = "H3";
var H3_default = H3;
export {
  H3_default as default,
  internalUseOnlyPriority3
};
